import { Component } from '@angular/core';
import { smoothlyMenu } from '../../../app.helpers';

@Component({
  selector: 'topnavigationnavbar',
  templateUrl: 'topnavigationnavbar.template.html'
})
export class TopNavigationNavbarComponent {

  toggleNavigation(): void {
    const x = document.getElementsByTagName('BODY')[0];
    x.classList.toggle('mini-navbar');
    smoothlyMenu();
  }

}
